import {
  ApiCreateMyWishlistRequestedAction,
  apiCreateMyWishlistFailed,
  apiCreateMyWishlistSucceeded
} from '@spa/lib/store/api/wishlists/createMyWishlistApi';
import { call, put } from 'typed-redux-saga';
import { WishlistError } from '@spa/components/wishlist/wishlistTypes';
import createMyWishlistAction from '@spa/lib/actions/wishlists/createMyWishlistAction';
import logger from '@spa/lib/logger';

function* createMyWishlistApiSaga({
  payload: { actionId: requestedActionId, input, parentActionId }
}: ApiCreateMyWishlistRequestedAction): Generator {
  try {
    const result = yield* call(createMyWishlistAction, 'createMyWishlistAction', input);

    if (result.__typename === 'CreateMyWishlistSucceededResult') {
      yield* put(
        apiCreateMyWishlistSucceeded({ parentActionId, requestedActionId, result: result.wishlist })
      );
    } else {
      yield* put(
        apiCreateMyWishlistFailed({ error: result.error, parentActionId, requestedActionId })
      );
    }
  } catch (e) {
    logger.error(e, 'Error creating my wishlist');

    yield* put(
      apiCreateMyWishlistFailed({
        error: WishlistError.UNKNOWN_ERROR,
        parentActionId,
        requestedActionId
      })
    );
  }
}

export default createMyWishlistApiSaga;
